import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FxContext = createContext({ rates: null, convert: (a) => a, refresh: () => {} });

export function FxProvider({ children }) {
  const { user } = useAuth();
  const [rates, setRates] = useState(null);
  const base = user?.currency || "USD";

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get(`/fx/rates?base=${base}`);
      setRates(data);
    } catch {
      setRates(null);
    }
  }, [base]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const convert = useCallback(
    (amount, from, to) => {
      const f = (from || base).toUpperCase();
      const t = (to || base).toUpperCase();
      if (f === t) return Number(amount) || 0;
      if (!rates || !rates.rates) return Number(amount) || 0;
      // Our cached rates are rebased to `base`. Convert via USD if needed.
      const fr = rates.rates[f]; const tr = rates.rates[t];
      if (!fr || !tr) return Number(amount) || 0;
      // amount in `from` * (base/from) * (to/base) = amount * tr / fr
      return (Number(amount) || 0) * (tr / fr);
    },
    [rates, base],
  );

  return (
    <FxContext.Provider value={{ rates, convert, refresh, base }}>
      {children}
    </FxContext.Provider>
  );
}

export const useFx = () => useContext(FxContext);
